import React from 'react';
import { useSelector } from 'react-redux';
import RowContainer from '../../common/CustomComponents/RowContainer';
import './allClaims.css';
import { usePageTitle } from '../../common/hooks/usePageTitle';

const Claims = () => {
  const tenantLayouts = useSelector(state => state.tenant.tenantLayout);
  usePageTitle('Claims');
  return (
    tenantLayouts['Claims'] &&
    <div className={tenantLayouts['Claims'].className} id={tenantLayouts['Claims'].id}>
      {tenantLayouts['Claims'].sections.map((item, index) => {
        return <RowContainer key={index} {...item} />;
      })}
    </div>

  );
};

export default Claims;
